var React = require('react');

function BoldChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.763 8.237 17.525 16l-7.762 7.763 2.474 2.474L22.475 16 12.237 5.763 9.763 8.237Z"}));
}

BoldChevronRight.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = BoldChevronRight;

BoldChevronRight.default = BoldChevronRight;
